import React from 'react';

const CircleCheckIcon = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill={props.fill ? props.fill : '#D5D5D5'} />
    <rect width="8" height="8" transform="translate(4 4)" fill={props.fill ? props.fill : '#D5D5D5'} />
    <path
      d="M10.6666 6L6.99998 9.66667L5.33331 8"
      stroke="white"
      stroke-width="1.44"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CircleCheckIcon;
